export interface DspBuyer {
  id: string;
  name: string;
}

export interface DspBuyersMeta {
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  hasNextPage: boolean;
  endCursor: string;
}

export interface DspBuyersResponse {
  items: DspBuyer[];
  meta: DspBuyersMeta;
}

export enum TtdBuyerType {
  Agency = 'AGENCY',
  Advertiser = 'ADVERTISER',
}

export interface DspBuyersQueryParams {
  limit?: number;
  after?: string;
  search?: string;
  buyerType?: TtdBuyerType;
  buyerId?: string;
}
